import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { AddWidgetModalContent } from '../../../AccountPerformanceReporting/components/AddWidgetModal/AddWidgetModal';
import { WidgetSlugDTO } from '../../api/useDefaultTemplateQuery';
import { FormValues } from '../../PersonalFinanceTemplate.meta';

interface Props {
  activeTab: WidgetSlugDTO;
  formBag: UseFormReturn<FormValues, any>;
  onClose: () => void;
}

export const AddWidgetModal = ({ activeTab, formBag, onClose }: Props) => {
  const widgets = formBag.watch('widgets')?.[activeTab];

  return (
    <AddWidgetModalContent
      widgets={widgets}
      onClose={() => onClose()}
      onSave={nextWidgets => {
        formBag.setValue(`widgets.${activeTab}`, nextWidgets);
      }}
    />
  );
};
